import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { IDLE, PENDING } from "const"
import { RrsCategory, RrsTemplateLabel, RrsTemplateLabelCategory } from "server/models"
import {
    StoreType,

    LoadAllRrsTemplateLabels,
    LoadAllRrsTemplateLabelCategories,
    LoadAllRrsTemplateLevels,
    CreateRrsTemplateLabelCategories,
    SetRrsTemplateRiskMapGenerated,
    DeleteRrsTemplateLabel,
    DeleteRrsTemplateLabelCategory,
    SortRrsCategories,

    setRrsTemplateEditLoadState,
    setRrsTemplateEdit,
    setRrsTemplateLabelList,
    setRrsTemplateLabelCategoryList,
    setRrsTemplateLevelList,
    addModal,
} from "client/store"
import { StateType } from "client/utils"
import {
    Collapse,
    PageForm,
    PageMenu,
    PageMenuButton,
    Tab,
    FormGroup,
    Label,
    Delimiter,
    Input,
    Textarea,
    Button,
    CheckButton,
    SpinnerIcon,

    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmDescription,
    ConfirmBottom,
} from "client/components"

import TemplateLabelEdit from "../labelEdit"
import TemplateLevelList from "../levelList"
import {
    ListTitleWrapper,
    LabelWrapper,
    LabelDeleteButton,
    CollapseButton,
    NestedCategoryDeleteButton,
    NestedCategoryOptionsButton,
} from "./styled"

interface TemplateLabelListProps {
    editAccess: boolean
}
const TemplateLabelList = ({
    editAccess,
}: TemplateLabelListProps) => {
    const labelList = useSelector((state: StoreType) => state.rrsTemplate.labelList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [show, setShow] = useState(true)

    return (
        <Collapse
            show={show}
            onCollapse={() => setShow(!show)}
            title={(
                <ListTitleWrapper>
                    <Label style={{ color: "inherit" }}>{lang.labels}</Label>
                    {
                        editAccess && (
                            <Button
                                variant="success"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    dispatch(addModal({
                                        key: "addLabel",
                                        content: <TemplateLabelEdit labelId={0} />,
                                    }))
                                }}
                            >
                                {lang.add}
                            </Button>
                        )
                    }
                </ListTitleWrapper>
            )}
        >
            {
                labelList && labelList.map((label) => (
                    <TemplateLabel
                        key={label.id}
                        label={label}
                        editAccess={editAccess}
                    />
                ))
            }
        </Collapse>
    )
}
export default TemplateLabelList


interface TemplateLabelProps {
    label: RrsTemplateLabel
    editAccess: boolean
}
const TemplateLabel = ({
    label,
    editAccess,
}: TemplateLabelProps) => {
    const template = useSelector((state: StoreType) => state.rrsTemplate.templateEdit)
    const labelCategoryList = useSelector((state: StoreType) => state.rrsTemplate.labelCategoryList)
    const categoryList = useSelector((state: StoreType) => state.rrsCategory.categoryList)
    const childParent = useSelector((state: StoreType) => state.rrsCategory.categoryChildParent)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [collapsed, setCollapsed] = useState(false)
    const [parentCategory, setParentCategory] = useState<string>(null)
    const [nestedCategories, setNestedCategories] = useState<RrsCategory[]>([])
    const [activeCategoryId, setActiveCategoryId] = useState<number>(null)

    // delete label
    const [showConfirmDeleteLabel, setShowConfirmDeleteLabel] = useState(false)
    const [deleteLabelState, setDeleteLabelState] = useState<StateType>(IDLE)

    // delete category
    const [deleteCategoryId, setDeleteCategoryId] = useState<number>(null)
    const [showConfirmDeleteCategory, setShowConfirmDeleteCategory] = useState(false)
    const [deleteCategoryState, setDeleteCategoryState] = useState<StateType>(IDLE)

    // select nested categories
    const [allNestedCategories, setAllNestedCategories] = useState<RrsCategory[]>([])
    const [selectedCategories, setSelectedCategories] = useState<number[]>([])
    const [showSelectNested, setShowSelectNested] = useState(false)
    const [selectNestedState, setSelectNestedState] = useState<StateType>(IDLE)

    useEffect(() => {
        const parentArray: string[] = []
        const addParent = (parentId: number) => {
            if (parentId) {
                const parent = categoryList[parentId]
                if (parent) parentArray.unshift(parent.shortName.length ? parent.shortName : parent.name)
                addParent(childParent[parentId])
            }
        }
        addParent(label.categoryId)
        setParentCategory(parentArray.length ? parentArray.join(" > ") : null)

        const allNested: RrsCategory[] = []
        Object.keys(childParent).forEach((key) => {
            const childId = Number(key)
            const parentId = childParent[childId]
            if (label.categoryId === parentId && categoryList[childId]) allNested.push(categoryList[childId])
        })
        const allNestedSorted = SortRrsCategories(allNested, {})
        setAllNestedCategories(allNestedSorted)
    }, [label, childParent, categoryList])

    useEffect(() => {
        const childCategories: RrsCategory[] = []
        const labelCategories = labelCategoryList[label.id] as number[] || []
        labelCategories.forEach((categoryId) => {
            if (categoryList[categoryId]) childCategories.push(categoryList[categoryId])
        })

        const childCategoriesSorted = SortRrsCategories(childCategories, {})
        setNestedCategories(childCategoriesSorted)
        setActiveCategoryId(childCategoriesSorted[0] ? childCategoriesSorted[0].id : null)
        setSelectedCategories(labelCategories)
    }, [labelCategoryList, categoryList])

    const onCancelDeleteLabel = () => {
        setShowConfirmDeleteLabel(false)
    }

    const onConfirmDeleteLabel = () => {
        setDeleteLabelState(PENDING)
        DeleteRrsTemplateLabel(label.id).then(() => {
            setDeleteLabelState(IDLE)
            setShowConfirmDeleteLabel(false)

            dispatch(setRrsTemplateEditLoadState(PENDING))
            LoadAllRrsTemplateLabels(template.id).then((res) => {
                dispatch(setRrsTemplateLabelList(res))

                SetRrsTemplateRiskMapGenerated([template.id], false).then(() => { // set riskMapGenerated to "false"
                    dispatch(setRrsTemplateEdit({
                        ...template,
                        riskMapGenerated: false,
                    }))
                    dispatch(setRrsTemplateEditLoadState(IDLE))
                })
            })
        })
    }

    const onCancelDeleteCategory = () => {
        setShowConfirmDeleteCategory(false)
    }

    const onConfirmDeleteCategory = () => {
        setDeleteCategoryState(PENDING)
        DeleteRrsTemplateLabelCategory(label.id, deleteCategoryId).then(() => {
            setDeleteCategoryState(IDLE)
            setShowConfirmDeleteCategory(false)

            dispatch(setRrsTemplateEditLoadState(PENDING))
            Promise.all([
                LoadAllRrsTemplateLabelCategories(label.id),
                LoadAllRrsTemplateLevels(label.id),
            ]).then(([newLabelCategories, newLevels]) => {
                dispatch(setRrsTemplateLabelCategoryList(label.id, newLabelCategories))
                dispatch(setRrsTemplateLevelList(label.id, newLevels))

                SetRrsTemplateRiskMapGenerated([template.id], false).then(() => { // set riskMapGenerated to "false"
                    dispatch(setRrsTemplateEdit({
                        ...template,
                        riskMapGenerated: false,
                    }))
                    dispatch(setRrsTemplateEditLoadState(IDLE))
                })
            })
        })
    }

    const onCancelSelectNested = () => {
        setShowSelectNested(false)
    }

    const onConfirmSelectNested = () => {
        setSelectNestedState(PENDING)
        const createLabelCategories: RrsTemplateLabelCategory[] = []
        const promiseArray: Promise<any>[] = []
        allNestedCategories.forEach((category) => {
            if (selectedCategories.includes(category.id)) {
                createLabelCategories.push({
                    labelId: label.id,
                    categoryId: category.id,
                })
            } else {
                promiseArray.push(
                    DeleteRrsTemplateLabelCategory(label.id, category.id),
                )
            }
        })
        promiseArray.push(
            CreateRrsTemplateLabelCategories(createLabelCategories),
        )

        Promise.all(promiseArray).then(() => {
            setSelectNestedState(IDLE)
            setShowSelectNested(false)

            dispatch(setRrsTemplateEditLoadState(PENDING))
            LoadAllRrsTemplateLabelCategories(label.id).then((res) => {
                dispatch(setRrsTemplateLabelCategoryList(label.id, res))
                SetRrsTemplateRiskMapGenerated([template.id], false).then(() => { // set riskMapGenerated to "false"
                    dispatch(setRrsTemplateEdit({
                        ...template,
                        riskMapGenerated: false,
                    }))
                    dispatch(setRrsTemplateEditLoadState(IDLE))
                })
            })
        })
    }

    return (
        <LabelWrapper collapsed={collapsed}>
            <PageForm noPaddingBottom>
                <Row>
                    <Col xs={12}>
                        <CollapseButton
                            collapsed={collapsed}
                            onClick={() => setCollapsed(!collapsed)}
                        />
                        {
                            editAccess && (
                                <LabelDeleteButton onClick={() => setShowConfirmDeleteLabel(true)}>
                                    {lang.delete}
                                </LabelDeleteButton>
                            )
                        }

                        <Label style={{ paddingLeft: "20px" }}>{`${label.name} (${label.shortName})`}</Label>
                        <Delimiter size="md" />

                        {
                            parentCategory && (
                                <FormGroup>
                                    <Label>{lang.category}</Label>
                                    <Input type="text" value={parentCategory} readOnly />
                                </FormGroup>
                            )
                        }
                        <FormGroup>
                            <Label>{lang.description}</Label>
                            <Textarea value={label.description} readOnly />
                        </FormGroup>
                        <FormGroup>
                            <Label>{lang.order}</Label>
                            <Input type="text" value={label.order} readOnly />
                        </FormGroup>

                        {
                            editAccess && (
                                <Button
                                    variant="success"
                                    onClick={() => dispatch(addModal({
                                        key: "editLabel",
                                        content: <TemplateLabelEdit labelId={label.id} />,
                                    }))}
                                >
                                    {lang.edit}
                                </Button>
                            )
                        }

                        <Delimiter size="md" />
                        <Label>{lang.levels}</Label>
                    </Col>
                </Row>
            </PageForm>

            {
                !label.categoryId && (
                    <TemplateLevelList
                        labelId={label.id}
                        categoryId={0}
                        editAccess={editAccess}
                    />
                )
            }
            {
                label.categoryId && (
                    <PageMenu>
                        {
                            nestedCategories.map((category) => (
                                <PageMenuButton
                                    key={category.id}
                                    isActive={activeCategoryId === category.id}
                                    onClick={() => setActiveCategoryId(category.id)}
                                >
                                    {category.shortName.length ? category.shortName : category.name}
                                    {
                                        editAccess && (
                                            <NestedCategoryDeleteButton
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    setDeleteCategoryId(category.id)
                                                    setShowConfirmDeleteCategory(true)
                                                }}
                                            />
                                        )
                                    }
                                </PageMenuButton>
                            ))
                        }
                        {
                            editAccess && (
                                <PageMenuButton
                                    isActive={false}
                                    onClick={() => setShowSelectNested(true)}
                                >
                                    <NestedCategoryOptionsButton />
                                </PageMenuButton>
                            )
                        }
                    </PageMenu>
                )
            }
            {
                nestedCategories.map((category) => (
                    <Tab
                        key={category.id}
                        show={activeCategoryId === category.id}
                    >
                        <TemplateLevelList
                            labelId={label.id}
                            categoryId={category.id}
                            editAccess={editAccess}
                        />
                    </Tab>
                ))
            }

            <ConfirmWrapper show={showConfirmDeleteLabel} onClose={onCancelDeleteLabel}>
                <Confirm>
                    <ConfirmTitle>{label.name}</ConfirmTitle>
                    <ConfirmDescription>{lang.deleteLabelConfirm}</ConfirmDescription>
                    <ConfirmBottom>
                        <Button variant="success" row onClick={onConfirmDeleteLabel}>
                            {deleteLabelState === PENDING ? <SpinnerIcon /> : lang.confirm}
                        </Button>
                        <Button row onClick={onCancelDeleteLabel}>{lang.cancel}</Button>
                    </ConfirmBottom>
                </Confirm>
            </ConfirmWrapper>

            <ConfirmWrapper show={showConfirmDeleteCategory} onClose={onCancelDeleteCategory}>
                <Confirm>
                    <ConfirmTitle>{categoryList[deleteCategoryId] && categoryList[deleteCategoryId].name}</ConfirmTitle>
                    <ConfirmDescription>{lang.deleteCategoryConfirm}</ConfirmDescription>
                    <ConfirmBottom>
                        <Button variant="success" row onClick={onConfirmDeleteCategory}>
                            {deleteCategoryState === PENDING ? <SpinnerIcon /> : lang.confirm}
                        </Button>
                        <Button row onClick={onCancelDeleteCategory}>{lang.cancel}</Button>
                    </ConfirmBottom>
                </Confirm>
            </ConfirmWrapper>

            <ConfirmWrapper show={showSelectNested} onClose={onCancelSelectNested}>
                <Confirm>
                    <ConfirmTitle>{lang.selectCategories}</ConfirmTitle>

                    <Row>
                        <Col xs={12}>
                            {
                                allNestedCategories.map((category) => {
                                    let rowTitle: string
                                    if (category.shortName.length) rowTitle = `${category.shortName} (${category.name})`
                                    else rowTitle = category.name

                                    return (
                                        <CheckButton
                                            key={category.id}
                                            title={rowTitle}
                                            checked={selectedCategories.includes(category.id)}
                                            onChange={() => {
                                                let newSelected = [...selectedCategories]
                                                if (newSelected.includes(category.id)) {
                                                    newSelected = newSelected.filter((id) => id !== category.id)
                                                } else {
                                                    newSelected.push(category.id)
                                                }
                                                setSelectedCategories(newSelected)
                                            }}
                                        />
                                    )
                                })
                            }
                        </Col>
                    </Row>

                    <ConfirmBottom>
                        <Button variant="success" row onClick={onConfirmSelectNested}>
                            {selectNestedState === PENDING ? <SpinnerIcon /> : lang.confirm}
                        </Button>
                        <Button row onClick={onCancelSelectNested}>{lang.cancel}</Button>
                    </ConfirmBottom>
                </Confirm>
            </ConfirmWrapper>
        </LabelWrapper>
    )
}
